// import { useQuery, useQueryClient } from "@tanstack/react-query";
// import React, { useEffect, useState, useMemo } from "react";
// import { useForm } from "react-hook-form";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   getServices,
//   getServicesFavorites,
//   getServicesTypes,
//   getStates,
// } from "../../api";
// import { MultiSelect } from "../../components/multiSelect";
// import { add_icon } from "../../icons/add";
// import { circle_add } from "../../icons/circle_add";
// import { exit_icon } from "../../icons/exit";
// import { dropdownStyles } from "../buy/buy";
// import { filters_icon } from "../../icons/new_fillter";
// import { search_icon } from "../../icons/search";
// import { EmptyStarIcon, FullStarIcon } from "../../icons/star";
// import { buy_icon, sell_icon } from "../../icons/state";
// import { useAuth } from "../../store/authProvider";
// import Client from "../../utils/client";
// import { useMutation } from "@tanstack/react-query";
// import ContactModal from "../../components/contact_modal";
// import notFound from "../../images/not-found.png";
// import ReactGA from "react-ga4";
// import { Helmet } from "react-helmet";
// import Skelton from "../../icons/skelton";
// import PlaceOrderModal from "../../components/place_order_modal";
// import Select from "react-select";

// const Services = () => {
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//     title: "Services Offers",
//   });
//   const { isAuth } = useAuth();
//   const [showContactModal, setShowContactModal] = useState(false);
//   const [showOrderModal, setShowOrderModal] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const navigator = useNavigate();

//   const {
//     register,
//     handleSubmit,
//     getValues,
//     formState: { errors },
//   } = useForm();
//   const [showModal, setShowModal] = useState(false);
//   const [offer, setOffer] = useState();
//   const [state, setState] = useState([]);
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [data, setData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [priceSort, setPriceSort] = useState(null);
//   const { data: states } = useQuery({
//     queryKey: ["states"],
//     queryFn: () => getStates(),
//     initialData: [],
//   });

//   const user_id = localStorage.getItem("user_id");

//   const {
//     data: services,
//     isFetching,
//     refetch,
//     error,
//   } = useQuery({
//     queryKey: ["services", priceSort],
//     queryFn: () =>
//       getServices(
//         "supply",
//         state.map((e) => e.value),
//         selectedServices.map((e) => e.value),
//         getValues().search_word === ""
//           ? getValues().search_words
//           : getValues().search_word,
//         page,
//         priceSort
//       ),
//     // onSuccess: (res) => setData([...new Set([...res.data])]),
//     onSuccess: (res) => {
//       if (page === 1) {
//         // first page → replace
//         setData(res.data);
//       } else {
//         // next pages → append
//         setData((prev) => [...prev, ...res.data]);
//       }
//     },

//     refetchOnWindowFocus: false,
//     initialData: [],
//   });

//   const { data: servicesTypes } = useQuery({
//     queryKey: ["servicesTypes"],
//     queryFn: () => getServicesTypes(),
//     initialData: [],
//   });

//   const getOffer = async (id) => {
//     const response = await Client.get(`/services/single/${id}`).then(
//       (res) => res.data
//     );
//     setOffer(response);
//     setShowModal(true);
//     const user_id = localStorage.getItem("user_id");
//     await Client.post("/admin/logs", {
//       user_id: isAuth ? user_id : null,
//       action: "Product View",
//       product_type: "Services Product",
//       product_id: id.toString(),
//     });
//   };

//   const onSubmit = (search) => {
//     refetch();
//   };
//   const queryClient = useQueryClient();
//   const mutation = useMutation({
//     mutationFn: (newTodo) => {
//       return Client.post(`/favorites/${offer.id}`, {
//         favorite_type: "service",
//       });
//     },
//     onSuccess: () => {
//       queryClient.invalidateQueries("favorites");
//     },
//   });
//   const { data: servicesFavorites } = useQuery({
//     queryKey: ["favorites"],
//     queryFn: () => getServicesFavorites(),
//     initialData: [],
//     enabled: isAuth,
//   });

//   const addFavorites = async () => {
//     mutation.mutate();
//   };
//   const handlePage = () => {
//     // setPage(page + 1);
//     setPage((prevPage) => prevPage + 1);
//   };

//   useEffect(() => {
//     refetch();
//   }, [page]);

//   if (error) {
//     return <div className="flex justify-center items-center">error</div>;
//   }

//   return (
//     <>
//       <Helmet>
//         ‍<title>عروض الخدمات - محصول</title>‍
//         <meta property="og:site_name" content="Mahsool" />
//         <meta name="keywords" content="Mahsool" />
//         <meta property="og:title" content="عروض الخدمات - محصول" />
//         <meta property="og:description" content="mahsool" />
//         <meta property="og:locale" content="en_US" />
//         <meta property="og:type" content="website" />
//       </Helmet>
//       {showFilters && (
//         <>
//           <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
//             <div className="relative max-w-3xl w-[350px] mx-auto my-6">
//               <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none h-[290px] p-3">
//                 <div
//                   className="text-red-600 w-8"
//                   onClick={() => setShowFilters(false)}
//                 >
//                   {exit_icon}
//                 </div>
//                 <div className="flex flex-col gap-5 h-full justify-center items-center">
//                   <p className="text-gray-400 font-bold text-lg">تخصيص البحث</p>
//                   <div className="w-full">
//                     <MultiSelect
//                       options={servicesTypes.map((e) => {
//                         return { label: e.name, value: e.id };
//                       })}
//                       value={selectedServices}
//                       onChange={setSelectedServices}
//                       placeHolder="الخدمة"
//                     />
//                   </div>
//                   <div className="w-full">
//                     <MultiSelect
//                       options={states.map((e) => {
//                         return { label: e.name, value: e.id };
//                       })}
//                       value={state}
//                       onChange={setState}
//                       placeHolder="المنطقة"
//                     />
//                   </div>
//                   <div
//                     className="w-28 h-10 bg-primary rounded-xl text-white font-bold flex justify-center items-center"
//                     onClick={() => (setShowFilters(false), refetch())}
//                   >
//                     موافق
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             className="fixed inset-0 z-40 bg-black opacity-25"
//             onClick={() => setShowFilters(false)}
//           ></div>
//         </>
//       )}

//       <>
//         {showModal ? (
//           <>
//             <div className="fixed inset-0 z-[10000] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
//               <div className="relative max-w-3xl w-[350px] mx-auto my-6">
//                 {/*content*/}
//                 <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none">
//                   {/*header*/}
//                   <div className="flex items-center justify-center p-4 rounded-t border-slate-200 ">
//                     <div className="w-full flex items-center justify-between">
//                       <div
//                         className="text-red-600 w-8"
//                         onClick={() => setShowModal(false)}
//                       >
//                         {exit_icon}
//                       </div>

//                       <div
//                         className="text-gray-500 w-8 active:scale-110"
//                         onClick={addFavorites}
//                       >
//                         {servicesFavorites.map((e) => e.id).includes(offer.id)
//                           ? FullStarIcon
//                           : EmptyStarIcon}
//                       </div>
//                     </div>
//                   </div>
//                   {/*body*/}
//                   <div className="flex justify-center h-[126px] bg-center bg-no-repeat bg-flipped-logo ">
//                     <img
//                       src={offer.service.image}
//                       className=" h-[100px]  self-center "
//                       alt=""
//                     />
//                   </div>
//                   <div className="w-full flex justify-center items-center font-bold mt-4 text-lg">
//                     {offer.service.name}
//                   </div>
//                   <div className="relative font-bold flex-auto px-4 border-2 my-4 mx-4 rounded-lg">
//                     <div className="flex flex-col gap-4 py-3" dir="rtl">
//                       <ModalTable
//                         description="الوصف  "
//                         value={offer.description}
//                       />
//                       <ModalTable
//                         description="الموقع  "
//                         value={offer._state.name}
//                       />

//                       {offer.price_per_day !== null && (
//                         <ModalTable
//                           description="نوع العمالة "
//                           value={offer.price_per_day}
//                         />
//                       )}

//                       {offer.number_of_workers !== null && (
//                         <ModalTable
//                           description="عدد العمال  "
//                           value={offer.number_of_workers}
//                         />
//                       )}

//                       {offer.quantity !== null && (
//                         <ModalTable
//                           description="الكمية  "
//                           value={offer.quantity}
//                         />
//                       )}

//                       {offer.type !== null && (
//                         <ModalTable description="النوع " value={offer.type} />
//                       )}

//                       {offer.payload !== null && (
//                         <ModalTable
//                           description="الحمولة "
//                           value={offer.payload}
//                         />
//                       )}

//                       {offer.line !== null && (
//                         <ModalTable description="الخط " value={offer.line} />
//                       )}

//                       {offer.temperature !== null && (
//                         <ModalTable
//                           description="درجة الحرارة "
//                           value={offer.temperature}
//                         />
//                       )}
//                       {offer.height !== null && (
//                         <ModalTable
//                           description="الإرتفاع  "
//                           value={offer.height}
//                         />
//                       )}

//                       {offer.space !== null && (
//                         <ModalTable
//                           description="المساحة  "
//                           value={offer.space}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   {/*footer*/}
//                   <button
//                     className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none  hover:shadow-lg focus:outline-none"
//                     type="button"
//                     onClick={() => (
//                       setShowModal(false),
//                       isAuth
//                         ? (setShowOrderModal(true),
//                           Client.post("/admin/logs", {
//                             user_id: isAuth ? user_id : null,
//                             action: "Product Order",
//                             product_type: "Services Product",
//                             product_id: offer.id.toString(),
//                           }))
//                         : navigator("/signin")
//                     )}
//                   >
//                     <div>طلب</div>
//                     {circle_add}
//                   </button>
//                 </div>
//               </div>
//             </div>
//             <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
//           </>
//         ) : null}
//       </>

//       <>
//         {showContactModal && (
//           <ContactModal
//             offer={offer}
//             setShowContactModal={setShowContactModal}
//           />
//         )}

//         {showOrderModal && (
//           <PlaceOrderModal
//             item={offer}
//             setShowOrderModal={setShowOrderModal}
//             tradeType={"Demand"}
//             negotiationType={"Service"}
//           />
//         )}
//       </>
//       <div className="grid w-11/12 grid-cols-2 gap-5 mt-10  lg:w-[81rem] lg:gap-3 lg:grid-flow-row lg:grid-cols-5 mx-8 lg:mx-0 lg:px-20">
//         {/* sm search */}
//         <div className=" text-sm lg:hidden w-full lg:col-span-5 lg:justify-start col-span-2 flex items-center lg:flex-row-reverse flex-col justify-center">
//           <div className="flex items-center justify-center h-12  font-bold text-white rounded-xl shadow-sm mb-4 w-full bg-primary  ">
//             <Link to={isAuth ? "/addserviceOffer" : "/signin"}>
//               <div className="flex items-center justify-center ">
//                 <div className="">إضافة خدمة</div>
//                 {add_icon}
//               </div>
//             </Link>
//           </div>
//           <div className="lg:w-1 h-1"></div>
//           <div className=" flex flex-col gap-1 lg:flex-row-reverse  bg-white rounded-md lg:w-full w-full">
//             <form
//               onSubmit={handleSubmit(onSubmit)}
//               className="flex justify-center items-center  w-full flex-row-reverse mb-[12px] h-[49px]"
//             >
//               <div className="rounded-full w-full border-[1px] border-secondary h-full flex justify-end items-center px-3 ">
//                 <input
//                   type="text"
//                   {...register("search_words")}
//                   className="border-0 bg-transparent w-full focus:ring-0 text-gray-400 font-bold placeholder:text-sm placeholder:text-gray-400"
//                   dir="rtl"
//                   placeholder="أبحث عن طلبك..."
//                 />
//                 {search_icon}
//               </div>
//             </form>

//             <form
//               onClick={handleSubmit(onSubmit)}
//               className="flex flex-col gap-4"
//             >
//               <MultiSelect
//                 options={servicesTypes.map((e) => {
//                   return { label: e.name, value: e.id };
//                 })}
//                 value={selectedServices}
//                 onChange={setSelectedServices}
//                 styles={dropdownStyles}
//                 placeHolder="الخدمة"
//               />
//               <MultiSelect
//                 options={states.map((e) => {
//                   return { label: e.name, value: e.id };
//                 })}
//                 value={state}
//                 onChange={setState}
//                 styles={dropdownStyles}
//                 placeHolder="المنطقة"
//               />
//               <Select
//                 isRtl={true}
//                 options={[
//                   { label: "الاحدث", value: "" },
//                   { label: "سعر تصاعدي", value: "asc" },
//                   { label: "سعر تنازلي", value: "desc" },
//                 ]}
//                 value={
//                   [
//                     { label: "الاحدث", value: "" },
//                     { label: "سعر تصاعدي", value: "asc" },
//                     { label: "سعر تنازلي", value: "desc" },
//                   ].find((opt) => opt.value === priceSort) || null
//                 }
//                 onChange={(selected) => {
//                   setPage(1);
//                   setPriceSort(selected?.value ?? null); // Only store value
//                 }}
//                 styles={dropdownStyles}
//                 placeholder="الاحدث"
//               />
//             </form>
//           </div>
//         </div>

//         {/* lg search */}
//         <div className="hidden w-full col-span-5  lg:flex flex-row-reverse mb-10 h-10">
//           <div className=" flex items-center justify-center h-[47px] text-sm font-bold text-white rounded-lg shadow-sm lg:h-full lg:text-lg  bg-primary  lg:w-[170px]">
//             <Link to={isAuth ? "/addserviceOffer" : "/signin"}>
//               <div className="flex flex-row-reverse items-center justify-center text-sm">
//                 <div className="">{add_icon}</div>
//                 <div className="">إضافة خدمة</div>
//               </div>
//             </Link>
//           </div>
//           <div className="w-[15px]" />
//           <div className="lg:w-1 h-1"></div>
//           <div className="w-full">
//             <form
//               onSubmit={handleSubmit(onSubmit)}
//               className="flex justify-center items-center h-full w-full flex-row-reverse"
//             >
//               <div className="rounded-full w-full border-[1px] border-primary h-full flex justify-end items-center px-3 ">
//                 <input
//                   type="text"
//                   {...register("search_word")}
//                   className="border-0 bg-transparent w-full focus:ring-0 text-gray-400 font-bold placeholder:text-sm placeholder:text-gray-400"
//                   dir="rtl"
//                   placeholder="أبحث عن طلبك..."
//                 />
//                 {search_icon}
//               </div>
//               <div className="w-[15px]" />
//               <div
//                 className="h-full px-2 border-primary rounded-xl border-[2px] flex justify-center items-center hover:cursor-pointer"
//                 onClick={() => setShowFilters(true)}
//               >
//                 {filters_icon}
//               </div>
//               <div className="w-[15px]" />
//               <div className="h-full px-2 border-primary rounded-xl border-[2px] flex justify-center items-center hover:cursor-pointer">
//                 {filters_icon}

//                 <div className="w-[15px]" />
//                 <select
//                   value={priceSort ?? ""}
//                   onChange={(e) => {
//                     const val = e.target.value;
//                     setPage(1);
//                     setPriceSort(
//                       val === "asc" ? "asc" : val === "desc" ? "desc" : null
//                     );
//                   }}
//                   className="appearance-none text-primary rounded-md border-none focus:outline-none focus:ring-0 pl-2 pr-6 py-1 text-center"
//                 >
//                   <option value="">الاحدث</option>
//                   <option value="asc"> سعر تصاعدي</option>
//                   <option value="desc">سعر تنازلي</option>
//                 </select>
//               </div>
//               <div className="w-[15px]" />
//               <div className="w-[15px]" />
//               <input
//                 type="submit"
//                 className="bg-primary rounded-md text-white h-full w-24 hover:cursor-pointer"
//                 value="بحث"
//               />
//             </form>
//           </div>
//         </div>

//         {data.length === 0 ? (
//           <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
//             <div className="font-bold mx-auto">
//               <img src={notFound} />
//             </div>
//             <div className="h-6"></div>
//             <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
//               عذراً لا توجد خدمات{" "}
//             </div>
//           </div>
//         ) : (
//           data?.map((item) => {
//             return (
//               <div
//                 className="relative flex flex-col items-center hover:scale-105 transition cursor-pointer  bg-white border-2 border-primary rounded-2xl h-auto lg:w-auto lg:h-auto lg:text-2xl max-w-[18rem] lg:max-w-full p-[10px]"
//                 key={item.id}
//                 onClick={() => getOffer(item.id)}
//               >
//                 <div className="place-self-end p-2">
//                   {item.service_type === "demand" ? (
//                     <div className="flex gap-3">
//                       <p className="text-sm text-primary font-bold">طلب</p>
//                       {buy_icon}
//                     </div>
//                   ) : (
//                     <div className="flex gap-3">
//                       <p className="text-sm text-primary font-bold">عرض</p>
//                       {sell_icon}
//                     </div>
//                   )}
//                 </div>
//                 <img src={item.service?.image} className="h-20 my-4" alt="" />
//                 <div className="font-bold text-lg mb-2">
//                   {item.service.name}
//                 </div>
//                 <div className=" text-sm mb-2">
//                   {`السعر باليوم : ${item.price_per_day ?? "غير متوفر"}`}
//                 </div>
//                 <div className="flex gap-2 justify-center items-center">
//                   <div className="text-sm font-medium">{item._state.name}</div>
//                   <div className=" text-primary">
//                     {servicesFavorites.map((e) => e.id).includes(item.id)
//                       ? FullStarIcon
//                       : EmptyStarIcon}
//                   </div>
//                 </div>
//               </div>
//             );
//           })
//         )}
//         {isFetching && (
//           <>
//             {[...Array(7).keys()].map((e, i) => (
//               <Skelton key={i} />
//             ))}
//           </>
//         )}
//       </div>
//       <div className="text-center">
//         {!isFetching && services.pageCount > services.page && (
//           <button
//             onClick={handlePage}
//             disabled={services.pageCount < services.page || isFetching}
//             className="bg-primary mt-8 text-white rounded-full py-1 px-4 hover:bg-[#42cf6a] hover:scale-105 transition disabled:opacity-50 disabled:animate-pulse"
//           >
//             عرض المزيد
//           </button>
//         )}
//       </div>
//     </>
//   );
// };

// export default Services;

// const ModalTable = ({ description, value }) => {
//   return (
//     <div className="flex gap-4">
//       <div className="flex">
//         <div className=" text-sm w-[80px] leading-relaxed font-bold">
//           {description}
//         </div>
//         <div className="text-black font-bold">:</div>
//       </div>

//       <div className="text-sm leading-relaxed font-bold ">{value}</div>
//     </div>
//   );
// };
import { useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getServices,
  getServicesFavorites,
  getServicesTypes,
  getStates,
} from "../../api";
import { MultiSelect } from "../../components/multiSelect";
import { add_icon } from "../../icons/add";
import { circle_add } from "../../icons/circle_add";
import { exit_icon } from "../../icons/exit";
import { dropdownStyles } from "../buy/buy";
import { filters_icon } from "../../icons/new_fillter";
import { search_icon } from "../../icons/search";
import { EmptyStarIcon, FullStarIcon } from "../../icons/star";
import { buy_icon, sell_icon } from "../../icons/state";
import { useAuth } from "../../store/authProvider";
import Client from "../../utils/client";
import { useMutation } from "@tanstack/react-query";
import ContactModal from "../../components/contact_modal";
import notFound from "../../images/not-found.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Skelton from "../../icons/skelton";
import PlaceOrderModal from "../../components/place_order_modal";
import Select from "react-select";

const Services = () => {
  const { t, i18n } = useTranslation();
  
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Services Offers",
  });
  
  const { isAuth } = useAuth();
  const [showContactModal, setShowContactModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const navigator = useNavigate();

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const [showModal, setShowModal] = useState(false);
  const [offer, setOffer] = useState();
  const [state, setState] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [priceSort, setPriceSort] = useState(null);
  
  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const user_id = localStorage.getItem("user_id");

  const {
    data: services,
    isFetching,
    refetch,
    error,
  } = useQuery({
    queryKey: ["services", priceSort],
    queryFn: () =>
      getServices(
        "supply",
        state.map((e) => e.value),
        selectedServices.map((e) => e.value),
        getValues().search_word === ""
          ? getValues().search_words
          : getValues().search_word,
        page,
        priceSort
      ),
    onSuccess: (res) => {
      if (page === 1) {
        setData(res.data);
      } else {
        setData((prev) => [...prev, ...res.data]);
      }
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const { data: servicesTypes } = useQuery({
    queryKey: ["servicesTypes"],
    queryFn: () => getServicesTypes(),
    initialData: [],
  });

  const getOffer = async (id) => {
    const response = await Client.get(`/services/single/${id}`).then(
      (res) => res.data
    );
    setOffer(response);
    setShowModal(true);
    const user_id = localStorage.getItem("user_id");
    await Client.post("/admin/logs", {
      user_id: isAuth ? user_id : null,
      action: "Product View",
      product_type: "Services Product",
      product_id: id.toString(),
    });
  };

  const onSubmit = (search) => {
    refetch();
  };
  
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (newTodo) => {
      return Client.post(`/favorites/${offer.id}`, {
        favorite_type: "service",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("favorites");
    },
  });
  
  const { data: servicesFavorites } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getServicesFavorites(),
    initialData: [],
    enabled: isAuth,
  });

  const addFavorites = async () => {
    mutation.mutate();
  };
  
  const handlePage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    refetch();
  }, [page]);

  if (error) {
    return <div className="flex justify-center items-center">{t("services.error")}</div>;
  }

  return (
    <>
      <Helmet>
        <title>{t("services.meta.title")}</title>
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content={t("services.meta.keywords")} />
        <meta property="og:title" content={t("services.meta.title")} />
        <meta property="og:description" content={t("services.meta.description")} />
        <meta property="og:locale" content={i18n.language === 'ar' ? 'ar_SA' : 'en_US'} />
        <meta property="og:type" content="website" />
      </Helmet>
      
      {showFilters && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div className="relative max-w-3xl w-[350px] mx-auto my-6">
              <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none h-[290px] p-3">
                <div
                  className="text-red-600 w-8 cursor-pointer"
                  onClick={() => setShowFilters(false)}
                >
                  {exit_icon}
                </div>
                <div className="flex flex-col gap-5 h-full justify-center items-center">
                  <p className="text-gray-400 font-bold text-lg">{t("services.customizeSearch")}</p>
                  <div className="w-full">
                    <MultiSelect
                      options={servicesTypes.map((e) => {
                        return { label: e.name, value: e.id };
                      })}
                      value={selectedServices}
                      onChange={setSelectedServices}
                      placeHolder={t("services.placeholders.service")}
                    />
                  </div>
                  <div className="w-full">
                    <MultiSelect
                      options={states.map((e) => {
                        return { label: e.name, value: e.id };
                      })}
                      value={state}
                      onChange={setState}
                      placeHolder={t("services.placeholders.region")}
                    />
                  </div>
                  <div
                    className="w-28 h-10 bg-primary rounded-xl text-white font-bold flex justify-center items-center cursor-pointer"
                    onClick={() => (setShowFilters(false), refetch())}
                  >
                    {t("services.ok")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="fixed inset-0 z-40 bg-black opacity-25"
            onClick={() => setShowFilters(false)}
          ></div>
        </>
      )}

      <>
        {showModal ? (
          <>
            <div className="fixed inset-0 z-[10000] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
              <div className="relative max-w-3xl w-[350px] mx-auto my-6">
                <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none">
                  <div className="flex items-center justify-center p-4 rounded-t border-slate-200">
                    <div className="w-full flex items-center justify-between">
                      <div
                        className="text-red-600 w-8 cursor-pointer"
                        onClick={() => setShowModal(false)}
                      >
                        {exit_icon}
                      </div>
                      <div
                        className="text-gray-500 w-8 active:scale-110 cursor-pointer"
                        onClick={addFavorites}
                      >
                        {servicesFavorites.map((e) => e.id).includes(offer.id)
                          ? FullStarIcon
                          : EmptyStarIcon}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center h-[126px] bg-center bg-no-repeat bg-flipped-logo">
                    <img
                      src={offer.service.image}
                      className="h-[100px] self-center"
                      alt=""
                    />
                  </div>
                  <div className="w-full flex justify-center items-center font-bold mt-4 text-lg">
                    {offer.service.name}
                  </div>
                  <div className="relative font-bold flex-auto px-4 border-2 my-4 mx-4 rounded-lg">
                    <div className="flex flex-col gap-4 py-3" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                      <ModalTable
                        description={t("services.modal.description")}
                        value={offer.description}
                      />
                      <ModalTable
                        description={t("services.modal.location")}
                        value={offer._state.name}
                      />
                      {offer.price_per_day !== null && (
                        <ModalTable
                          description={t("services.modal.laborType")}
                          value={offer.price_per_day}
                        />
                      )}
                      {offer.number_of_workers !== null && (
                        <ModalTable
                          description={t("services.modal.numberOfWorkers")}
                          value={offer.number_of_workers}
                        />
                      )}
                      {offer.quantity !== null && (
                        <ModalTable
                          description={t("services.modal.quantity")}
                          value={offer.quantity}
                        />
                      )}
                      {offer.type !== null && (
                        <ModalTable
                          description={t("services.modal.type")}
                          value={offer.type}
                        />
                      )}
                      {offer.payload !== null && (
                        <ModalTable
                          description={t("services.modal.payload")}
                          value={offer.payload}
                        />
                      )}
                      {offer.line !== null && (
                        <ModalTable
                          description={t("services.modal.line")}
                          value={offer.line}
                        />
                      )}
                      {offer.temperature !== null && (
                        <ModalTable
                          description={t("services.modal.temperature")}
                          value={offer.temperature}
                        />
                      )}
                      {offer.height !== null && (
                        <ModalTable
                          description={t("services.modal.height")}
                          value={offer.height}
                        />
                      )}
                      {offer.space !== null && (
                        <ModalTable
                          description={t("services.modal.space")}
                          value={offer.space}
                        />
                      )}
                    </div>
                  </div>
                  <button
                    className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none hover:shadow-lg focus:outline-none"
                    type="button"
                    onClick={() => (
                      setShowModal(false),
                      isAuth
                        ? (setShowOrderModal(true),
                          Client.post("/admin/logs", {
                            user_id: isAuth ? user_id : null,
                            action: "Product Order",
                            product_type: "Services Product",
                            product_id: offer.id.toString(),
                          }))
                        : navigator("/signin")
                    )}
                  >
                    <div>{t("services.modal.request")}</div>
                    {circle_add}
                  </button>
                </div>
              </div>
            </div>
            <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
          </>
        ) : null}
      </>

      <>
        {showContactModal && (
          <ContactModal
            offer={offer}
            setShowContactModal={setShowContactModal}
          />
        )}
        {showOrderModal && (
          <PlaceOrderModal
            item={offer}
            setShowOrderModal={setShowOrderModal}
            tradeType={"Demand"}
            negotiationType={"Service"}
          />
        )}
      </>
      
      <div className="grid w-11/12 grid-cols-2 gap-5 mt-10 lg:w-[81rem] lg:gap-3 lg:grid-flow-row lg:grid-cols-5 mx-8 lg:mx-0 lg:px-20">
        {/* Mobile search */}
        <div className="text-sm lg:hidden w-full lg:col-span-5 lg:justify-start col-span-2 flex items-center lg:flex-row-reverse flex-col justify-center">
          <div className="flex items-center justify-center h-12 font-bold text-white rounded-xl shadow-sm mb-4 w-full bg-primary">
            <Link to={isAuth ? "/addserviceOffer" : "/signin"}>
              <div className="flex items-center justify-center">
                <div className="">{t("services.addService")}</div>
                {add_icon}
              </div>
            </Link>
          </div>
          <div className="lg:w-1 h-1"></div>
          <div className="flex flex-col gap-1 lg:flex-row-reverse bg-white rounded-md lg:w-full w-full">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex justify-center items-center w-full flex-row-reverse mb-[12px] h-[49px]"
            >
              <div className="rounded-full w-full border-[1px] border-secondary h-full flex justify-end items-center px-3">
                <input
                  type="text"
                  {...register("search_words")}
                  className="border-0 bg-transparent w-full focus:ring-0 text-gray-400 font-bold placeholder:text-sm placeholder:text-gray-400"
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  placeholder={t("services.placeholders.search")}
                />
                {search_icon}
              </div>
            </form>

            <form onClick={handleSubmit(onSubmit)} className="flex flex-col gap-4">
              <MultiSelect
                options={servicesTypes.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={selectedServices}
                onChange={setSelectedServices}
                styles={dropdownStyles}
                placeHolder={t("services.placeholders.service")}
              />
              <MultiSelect
                options={states.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={state}
                onChange={setState}
                styles={dropdownStyles}
                placeHolder={t("services.placeholders.region")}
              />
              <Select
                isRtl={i18n.language === 'ar'}
                options={[
                  { label: t("services.sort.latest"), value: "" },
                  { label: t("services.sort.priceAsc"), value: "asc" },
                  { label: t("services.sort.priceDesc"), value: "desc" },
                ]}
                value={
                  [
                    { label: t("services.sort.latest"), value: "" },
                    { label: t("services.sort.priceAsc"), value: "asc" },
                    { label: t("services.sort.priceDesc"), value: "desc" },
                  ].find((opt) => opt.value === priceSort) || null
                }
                onChange={(selected) => {
                  setPage(1);
                  setPriceSort(selected?.value ?? null);
                }}
                styles={dropdownStyles}
                placeholder={t("services.sort.latest")}
              />
            </form>
          </div>
        </div>

        {/* Desktop search */}
        <div className="hidden w-full col-span-5 lg:flex flex-row-reverse mb-10 h-10">
          <div className="flex items-center justify-center h-[47px] text-sm font-bold text-white rounded-lg shadow-sm lg:h-full lg:text-lg bg-primary lg:w-[170px]">
            <Link to={isAuth ? "/addserviceOffer" : "/signin"}>
              <div className="flex flex-row-reverse items-center justify-center text-sm">
                <div className="">{add_icon}</div>
                <div className="">{t("services.addService")}</div>
              </div>
            </Link>
          </div>
          <div className="w-[15px]" />
          <div className="lg:w-1 h-1"></div>
          <div className="w-full">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex justify-center items-center h-full w-full flex-row-reverse"
            >
              <div className="rounded-full w-full border-[1px] border-primary h-full flex justify-end items-center px-3">
                <input
                  type="text"
                  {...register("search_word")}
                  className="border-0 bg-transparent w-full focus:ring-0 text-gray-400 font-bold placeholder:text-sm placeholder:text-gray-400"
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  placeholder={t("services.placeholders.search")}
                />
                {search_icon}
              </div>
              <div className="w-[15px]" />
              <div
                className="h-full px-2 border-primary rounded-xl border-[2px] flex justify-center items-center hover:cursor-pointer"
                onClick={() => setShowFilters(true)}
              >
                {filters_icon}
              </div>
              <div className="w-[15px]" />
              <div className="h-full px-2 border-primary rounded-xl border-[2px] flex justify-center items-center hover:cursor-pointer">
                {filters_icon}
                <div className="w-[15px]" />
                <select
                  value={priceSort ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPage(1);
                    setPriceSort(
                      val === "asc" ? "asc" : val === "desc" ? "desc" : null
                    );
                  }}
                  className="appearance-none text-primary rounded-md border-none focus:outline-none focus:ring-0 pl-2 pr-6 py-1 text-center"
                >
                  <option value="">{t("services.sort.latest")}</option>
                  <option value="asc">{t("services.sort.priceAsc")}</option>
                  <option value="desc">{t("services.sort.priceDesc")}</option>
                </select>
              </div>
              <div className="w-[15px]" />
              <div className="w-[15px]" />
              <input
                type="submit"
                className="bg-primary rounded-md text-white h-full w-24 hover:cursor-pointer"
                value={t("services.search")}
              />
            </form>
          </div>
        </div>

        {data.length === 0 ? (
          <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
            <div className="font-bold mx-auto">
              <img src={notFound} alt={t("services.noServices")} />
            </div>
            <div className="h-6"></div>
            <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold">
              {t("services.noServices")}
            </div>
          </div>
        ) : (
          data?.map((item) => {
            return (
              <div
                className="relative flex flex-col items-center hover:scale-105 transition cursor-pointer bg-white border-2 border-primary rounded-2xl h-auto lg:w-auto lg:h-auto lg:text-2xl max-w-[18rem] lg:max-w-full p-[10px]"
                key={item.id}
                onClick={() => getOffer(item.id)}
              >
                <div className="place-self-end p-2">
                  {item.service_type === "demand" ? (
                    <div className="flex gap-3">
                      <p className="text-sm text-primary font-bold">{t("services.request")}</p>
                      {buy_icon}
                    </div>
                  ) : (
                    <div className="flex gap-3">
                      <p className="text-sm text-primary font-bold">{t("services.offer")}</p>
                      {sell_icon}
                    </div>
                  )}
                </div>
                <img src={item.service?.image} className="h-20 my-4" alt="" />
                <div className="font-bold text-lg mb-2">
                  {item.service.name}
                </div>
                <div className="text-sm mb-2">
                  {t("services.pricePerDay", { price: item.price_per_day ?? t("services.notAvailable") })}
                </div>
                <div className="flex gap-2 justify-center items-center">
                  <div className="text-sm font-medium">{item._state.name}</div>
                  <div className="text-primary">
                    {servicesFavorites.map((e) => e.id).includes(item.id)
                      ? FullStarIcon
                      : EmptyStarIcon}
                  </div>
                </div>
              </div>
            );
          })
        )}
        {isFetching && (
          <>
            {[...Array(7).keys()].map((e, i) => (
              <Skelton key={i} />
            ))}
          </>
        )}
      </div>
      <div className="text-center">
        {!isFetching && services.pageCount > services.page && (
          <button
            onClick={handlePage}
            disabled={services.pageCount < services.page || isFetching}
            className="bg-primary mt-8 text-white rounded-full py-1 px-4 hover:bg-[#42cf6a] hover:scale-105 transition disabled:opacity-50 disabled:animate-pulse"
          >
            {t("services.showMore")}
          </button>
        )}
      </div>
    </>
  );
};

export default Services;

const ModalTable = ({ description, value }) => {
  return (
    <div className="flex gap-4">
      <div className="flex">
        <div className="text-sm w-[80px] leading-relaxed font-bold">
          {description}
        </div>
        <div className="text-black font-bold">:</div>
      </div>
      <div className="text-sm leading-relaxed font-bold">{value}</div>
    </div>
  );
};